import { createAsyncStore } from "./create-async-store";

export const asyncStore = createAsyncStore();
